"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTERPRISE_DISPATCH_SINGLE_WORK_ORDER_EVENT = exports.ENTERPRISE_SCHEDULE_SINGLE_WORK_ORDER_EVENT = exports.ENTERPRISE_CONTRACT_EVENT = void 0;
exports.ENTERPRISE_CONTRACT_EVENT = 'enterprise_contract_event';
exports.ENTERPRISE_SCHEDULE_SINGLE_WORK_ORDER_EVENT = 'enterprise_schedule_single_work_order_event';
exports.ENTERPRISE_DISPATCH_SINGLE_WORK_ORDER_EVENT = 'enterprise_dispatch_single_work_order_event';
